import Home from "./Pages/Home";
import About from "./Pages/About";
import People from "./Pages/People";
import Profile from "./Pages/Profile";
import Practices from "./Pages/Practices";
import Contact from "./Pages/Contact";
import Blog from "./Pages/Blog";
import Practice from "./Pages/Practice";
import { ThankYou } from "./Pages/ThankYou";
export const ROUTES = [
  { name: "Home", path: "/", component: Home, showInMenu: true },
  { name: "People", path: "/people", component: People, showInMenu: true },
  {
    name: "Practices",
    path: "/practices",
    component: Practices,
    showInMenu: true
  },
  {
    name: "Practice",
    path: "/practices/:id",
    component: Practice,
    showInMenu: false
  },
  { name: "About", path: "/about", component: About, showInMenu: true },
  { name: "Blog", path: "/blog", component: Blog, showInMenu: true },
  { name: "Contact", path: "/contact", component: Contact, showInMenu: true },
  {
    name: "Profile",
    path: "/people/:id",
    component: Profile,
    showInMenu: false
  },
  {
    name: "Thank You",
    path: "/thank-you",
    component: ThankYou,
    showInMenu: false
  }
];
